import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import { getUserId, getAccesstoken } from '../../../utils/auth';
import { Link } from 'react-router-dom';
import { Buffer } from "buffer";
import { getScoreInterpretation } from "../../../utils/ScoreInterpretation";
import {
    fetchAbdominalAssessmentResponse,
    fetchPrediabetesAssessmentResponse,
    fetchOutcomesByAsssessmentAndUserId,
    fetchIRAssessmentResponse
} from '../../../api/AssessmentHelper';
// import { generateMedicalAssessmentReport } from '../../../utils/pdfGeneratorMedicalAssessment';
import {generateFullMedicalAssessmentReport} from '../../../utils/MedicalPdfGenerator';

const ViewMedicalResponses = () => {
    const [responses, setResponses] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [fastingBloodGlucose, setFastingBloodGlucose] = useState(null);
    const [hba1c, setHBA1C] = useState(null);
    const [serumFastingInsulin, setSerumFastingInsulin] = useState(null);
    const [triglycerides, setTriglycerides] = useState(null);
    const [physicallyActive, setPhysicallyActive] = useState(null);
    const [hdl, setHDL] = useState(null);
    const [homaIr, setHOMAIR] = useState(null);
    const [tyGIndex, setTyGIndex] = useState(null);
    const [hdlRatio, setHDLRatio] = useState(null);
    const [parentSiblingsDiabetes, setParentSiblingsDiabetes] = useState(null);

    const [waistcm, setWaistCm] = useState(null);
    const [waistToHeight, setWaistToHeight] = useState(null);
    const [bri, setBRI] = useState(null);
    const [bmi, setBMI] = useState(null);
    const [matchingConditions, setMatchingConditions] = useState([]);
    const [assessmentOutcome, setAssessmentOutcome] = useState(null);
    const [bmiRange, setBMIRnge] = useState(null);

    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const access_token = getAccesstoken();
    const user_id = getUserId();

    const searchParams = new URLSearchParams(location.search);
    const encodedData = searchParams.get("details");
    // const { name: assessmentName } = JSON.parse(Buffer.from(decodeURIComponent(encodedData), "base64").toString("utf-8"));
    let assessmentName = ""; // Define outside so it's accessible

    if (encodedData) {
        try {
            const decodedString = Buffer.from(decodeURIComponent(encodedData), "base64").toString("utf-8");
            const parsedData = JSON.parse(decodedString);
            assessmentName = parsedData.name || ""; // Assign value if it exists
        } catch (error) {
            console.error("Error decoding JSON:", error);
        }
    } else {
        console.warn("No encoded data found in URL parameters.");
    }

    const encodeData = (name) => {
        const obj = { name };
        return encodeURIComponent(Buffer.from(JSON.stringify(obj)).toString("base64"));
    };
    // Updated assessmentQuestions to match StartMedicalAssessment.js
    const assessmentQuestions = {
        "7a54fd47-a449-46fc-8fbc-a5e12d2b7c6f": [
            { id: "ao_q1", question_text: "Height (in cm)?", question_type: "text_input", key: "height" },
            { id: "ao_q2", question_text: "Weight (kg)?", question_type: "text_input", key: "weight" },
            { id: "ao_q3", question_text: "Age?", question_type: "text_input", key: "age" },
            { id: "ao_q4", question_text: "Body Mass Index (BMI)?", question_type: "text_input", key: "bmi" },
            { id: "ao_q5", question_text: "Gender?", question_type: "radio", key: "gender" },
            { id: "ao_q6", question_text: "Waist circumference (cm)", question_type: "text_input", key: "waist_circumference" },
            { id: "ao_q7", question_text: "Waist to Height Ratio (WtH Ratio)", question_type: "text_input", key: "waist_height_ratio" },
            { id: "ao_q8", question_text: "Body Roundness Index", question_type: "text_input", key: "bri" }
        ],
        "4b2f9c68-df89-421a-9872-098e01b7a2ef": [
            { id: "pd_q1", question_text: "Pre-diabetes risk score", question_desc: "Have you taken the test? Do you have higher risk of pre-diabetes?", question_type: "radio", key: "prediabetes_risk_score" },
            { id: "pd_q2", question_text: "Serum Fasting Insulin (mIU/L)", question_type: "text_input", key: "serum_fasting_insulin" },
            { id: "pd_q3", question_text: "Fasting Blood glucose (mg/dl)", question_type: "text_input", key: "fasting_blood_glucose" },
            { id: "pd_q4", question_text: "HbA1c (%)", question_type: "text_input", key: "hba1c" },
            { id: "pd_q5", question_text: "Triglycerides", question_type: "text_input", key: "triglycerides" },
            { id: "pd_q6", question_text: "HDL", question_type: "text_input", key: "hdl" },
            { id: "pd_q7", question_text: "Do you have a parent or sibling with type 2 diabetes", question_type: "radio", key: "parent_sibling_diabetes" },
            { id: "pd_q8", question_text: "Are you physically active < 3 times a week?", question_type: "radio", key: "physically_active" }
        ],
        "cdf191f0-020d-45de-b9c9-a3bfa5610fcc": [
            { id: "ir1", question_text: "HOMA IR (Insulin resistance)", question_type: "text_input", key: "homa_ir" },
            { id: "ir2", question_text: "Triglyceride Glucose index (TyG)", question_type: "text_input", key: "tyg_index" },
            { id: "ir3", question_text: "Triglyceride HDL ratio ", question_type: "text_input", key: "hdl_ratio" }
        ]

    };

    const calculateScore = useCallback((responseData) => {
        let totalScore = 0;
        let matchingConditions = [];

        if (assessmentName === 'Abdominal Obesity') {
            const waistCircumference = parseFloat(responseData.waist_circumference);
            const gender = responseData.gender;
            const waisttoHeightRatio = parseFloat(responseData.waist_height_ratio);
            const BRI = parseFloat(responseData.bri);
            const BMI = parseFloat(responseData.bmi);


            if (!isNaN(waistCircumference)) {
                if (gender.trim() === "Male" && waistCircumference > 94) {
                    totalScore += 1;
                    matchingConditions.push('Waist Circumference');
                } else if (gender.trim() === "Female" && waistCircumference > 80) {
                    totalScore += 1;
                    matchingConditions.push('Waist Circumference');
                }
            }
            if (!isNaN(waisttoHeightRatio) && waisttoHeightRatio > 0.5) {
                totalScore += 1;
                matchingConditions.push('Waist to Height Ratio');
            }
            if (!isNaN(BRI) && BRI > 7) {
                totalScore += 1;
                matchingConditions.push('BRI');
            }  
            if (!isNaN(BMI) && BMI < 16) {
                setBMIRnge('Severe Thinness');
            }
            if (!isNaN(BMI) && BMI >= 16 && BMI < 17) {
                setBMIRnge('Moderate Thinness');
            }
            if (!isNaN(BMI) && BMI >= 17 && BMI < 18.5) {
                setBMIRnge('Mild Thinness');
            }
            if (!isNaN(BMI) && BMI >= 18.5 && BMI < 25) {
                setBMIRnge('Normal');
            }
            if (!isNaN(BMI) && BMI >= 25 && BMI < 30) {
                setBMIRnge('Overweight');
            }
            if (!isNaN(BMI) && BMI >= 30 && BMI < 35) {
                setBMIRnge('Obesity Class I');
            }
            if (!isNaN(BMI) && BMI >= 35 && BMI < 40) {
                setBMIRnge('Obesity Class II');
            }
            if (!isNaN(BMI) && BMI >= 40) {
                setBMIRnge('Obesity Class III');
            }
        } else if (assessmentName === 'Insulin Resistance and Pre-diabetes') {
            const insulin = parseFloat(responseData.serum_fasting_insulin);
            const glucose = parseFloat(responseData.fasting_blood_glucose);
            const hba1c = parseFloat(responseData.hba1c);
            const hasFamily = responseData.parent_sibling_diabetes === 'Yes';
            const isInactive = responseData.physically_active === 'Yes';

            const homaIr = parseFloat(responseData.homa_ir);
            const tygIndex = parseFloat(responseData.tyg_index);
            const hdlRatio = parseFloat(responseData.hdl_ratio);
            const gender = responseData.gender?.trim();

            // Insulin Resistance conditions
            if (!isNaN(homaIr) && homaIr > 1.85 && gender === 'Male') {
                totalScore += 1;
                matchingConditions.push('HOMA-IR');
            }

            if (!isNaN(homaIr) && homaIr > 2.07 && gender === 'Female') {
                totalScore += 1;
                matchingConditions.push('HOMA-IR');
            }

            if (!isNaN(tygIndex) && tygIndex > 4.65) {
                totalScore += 1;
                matchingConditions.push('TyG Index');
            }

            if (!isNaN(hdlRatio)) {
                if ((gender === 'Male' && hdlRatio > 3.4) || 
                    (gender === 'Female' && hdlRatio > 2.6)) {
                    totalScore += 1;
                    matchingConditions.push('Triglyceride-HDL Ratio');
                }
            }
        }

        return { totalScore, matchingConditions };
    }, [assessmentName, tyGIndex]);


    useEffect(() => {
        const fetchMedicalResponses = async () => {
            if (!params.assessmentId || !access_token) {
                setError('Please login to continue');
                return;
            }

            try {
                setLoading(true);
                setError(null);

                let response;
                let response1;
                // Fetch responses based on assessment ID
                if (params.assessmentId === "7a54fd47-a449-46fc-8fbc-a5e12d2b7c6f") {
                    response = await fetchAbdominalAssessmentResponse(user_id, access_token);
                    
                    setResponses(response);
                    setBRI(response.bri);
                    setWaistToHeight(response.waist_height_ratio)
                    setWaistCm(response.waist_circumference)
                    setBMI(response.bmi)
                    
                    // Get both score and matching conditions
                    const { totalScore, matchingConditions } = calculateScore(response);

                    setMatchingConditions(matchingConditions);
                } else if (params.assessmentId === "4b2f9c68-df89-421a-9872-098e01b7a2ef") {
                    response = await fetchPrediabetesAssessmentResponse(user_id, access_token);
                    response1 = await fetchIRAssessmentResponse(user_id, access_token);

                    // Set all state values
                    setFastingBloodGlucose(response.fasting_blood_glucose);
                    setHBA1C(response.hba1c);
                    setSerumFastingInsulin(response.serum_fasting_insulin);
                    setTriglycerides(response.triglycerides);
                    setHDL(response.hdl);
                    // setGender(response.gender);
                    setParentSiblingsDiabetes(response.parent_sibling_diabetes);
                    setPhysicallyActive(response.physically_active);
                    setHOMAIR(response1.homa_ir);
                    setTyGIndex(response1.tyg_index);
                    setHDLRatio(response1.hdl_ratio);

                    // Combine both responses into a single object
                    const combinedResponse = {
                        ...response,
                        ...response1,
                        gender: response.gender // Make sure gender is included if needed for calculations
                    };


                    // Pass combined response to calculateScore
                    const { totalScore, matchingConditions } = calculateScore(combinedResponse);
                    setMatchingConditions(matchingConditions);
                }


                const assessmentOutcome = await fetchOutcomesByAsssessmentAndUserId(params.assessmentId, user_id, access_token);
                if (assessmentOutcome) {
                    setResponses(response);
                    const totalScore = assessmentOutcome.total_score;
                    setAssessmentOutcome({ total_score: totalScore });
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error.message || 'Failed to load responses');
            } finally {
                setLoading(false);
            }
        };

        fetchMedicalResponses();
    }, [params.assessmentId, access_token, user_id, calculateScore]);

    const handleBack = () => {
        navigate(-1);
    };

    const handleDownloadPDF = async () => {
        try {
            setGeneratingPDF(true);
            setError(null);
    
            // Combine all the state values into a single response object
            const combinedResponses = {
                bmi,
                bmi_range: bmiRange,
                waist_circumference: waistcm,
                waist_height_ratio: waistToHeight,
                bri,
                matching_conditions: matchingConditions,
                serum_fasting_insulin: serumFastingInsulin,
                fasting_blood_glucose: fastingBloodGlucose,
                hba1c,
                parent_sibling_diabetes: parentSiblingsDiabetes,
                physically_active: physicallyActive,
                homa_ir: homaIr,
                tyg_index: tyGIndex,
                hdl_ratio: hdlRatio,
                gender: responses?.gender
            };
    
            const pdfDoc = await generateFullMedicalAssessmentReport(assessmentName, combinedResponses);
            await pdfDoc.download(`${assessmentName}_Report_${new Date().toLocaleDateString()}.pdf`);
        } catch (err) {
            console.error('Error generating PDF:', err);
            setError('Failed to generate PDF report. Please try again.');
        } finally {
            setGeneratingPDF(false);
        }
    };

    if (loading) return <div className="d-flex justify-content-center"><ClipLoader /></div>;
    if (error) return <div className="error-message">{error}</div>;

    const { interpretation, out_of_score, adjustedScore } = getScoreInterpretation(
        assessmentName,
        assessmentOutcome?.total_score || 0,
        {
            waistCircumference: responses?.waist_circumference,
            wthRatio: responses?.waist_to_height_ratio,
            bri: responses?.body_roundness_index,
            gender: responses?.gender,
        }
    );

    return (
        <div className="view-responses-container">
            <div className="row mb-4">
                <div className="col-xl-12">
                    <div className="d-flex gap-2">
                        <div className="font-md fw-semibold">Results for {assessmentName} Assessment</div>

                        <div style={{ display: "flex", justifyContent: "flex-end", width: "30%" }}>
                            <Link style={{ fontSize: "22px" }} onClick={handleBack}>
                                <i className="fa-solid fa-left-long icon"></i> Back
                            </Link>
                        </div>

                    </div>
                    <div className="assesment-cards">
                        {assessmentName === 'Abdominal Obesity' ? (
                            <>
                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Your BMI is {bmi}.</span> You are having {bmiRange}
                                </h5>
                                {bmi > 25 && (
                                    <h5 className='result' style={{marginBottom: '15px'}}>Being overweight or obese is a risk factor for pre-diabetes and heart diseases</h5>
                                )}
                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Your Waist Circumference is:</span> {waistcm} cm
                                    {responses?.gender && waistcm && (
                                        responses.gender.trim() === "Male" && waistcm > 94 ? (
                                             "- You are having abdominal obesity"
                                        ) : responses.gender.trim() === "Female" && waistcm > 80 ? (
                                            " - You are having abdominal obesity"
                                        ) : null
                                    )}
                                </h5>
                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Waist to Height Ratio is:</span> {waistToHeight}
                                    {waistToHeight > 0.5 && " - It is above normal limit"}
                                </h5>
                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Body Roundness Index is:</span> {bri}
                                    {bri > 7 && " - It is above normal limit"}
                                </h5>

                                {/* <h5 className='result' style={{marginBottom: '15px'}}>
                                    Your score in {matchingConditions.length > 0 ? 
                                        matchingConditions.join(', ') : ''} 
                                    {matchingConditions.length > 0 ? 
                                        ` is positive. It indicates Abdominal obesity and insulin resistance. It is an independent risk factor for heart diseases, diabetes and polycystic ovarian syndrome, fatty liver etc.` : 
                                        ' is normal.'}
                                </h5> */}
                                {matchingConditions.length > 0 && (
                                    <h5 className='result' style={{marginBottom: '15px'}}>
                                        Your scores in <span style={{fontWeight: 'bold'}}>{matchingConditions.join(', ')} </span> are higher than the normal limits. It indicates Abdominal obesity and insulin resistance. It is an independent risk factor for heart diseases, diabetes and polycystic ovarian syndrome, fatty liver etc.
                                    </h5>
                                )}
                            </>
                        ) : assessmentName === 'Insulin Resistance and Pre-diabetes' ? (
                            <>
                                {/* Commented pre-diabetes area */}
                                {/* <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Serum Fasting Insulin:</span> {serumFastingInsulin} mIU/L
                                    {serumFastingInsulin > 15 && 
                                        " - Indicates hyperinsulinemia"}
                                </h5>

                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Fasting Blood Glucose:</span> {fastingBloodGlucose} mg/dl
                                    {fastingBloodGlucose > 126 ? 
                                        " - High chances of diabetes" :
                                        fastingBloodGlucose > 110 ?
                                        " - High chances of pre-diabetes" : 
                                        " - Normal range"}
                                </h5>

                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>HbA1c:</span> {hba1c}%
                                    {hba1c >= 6.5 ? 
                                        " - You may be at higher risk of diabetes" :
                                        hba1c >= 5.7 ?
                                        " - You may be at higher risk of pre-diabetes" :
                                        " - Normal A1c value"}
                                </h5>

                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Do you have a parent or sibling with type 2 diabetes:</span> {parentSiblingsDiabetes}
                                    {parentSiblingsDiabetes === 'Yes' &&
                                        " - History of diabetes in the family (parents or sibling) is one of the risk factor for Pre-diabetes"}
                                </h5>

                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Physical Activity Less than 3 times/week:</span> {physicallyActive}
                                    {physicallyActive === 'Yes' &&
                                        " - Being physically inactive or less active (< 3 times a week)  is one of the  risk factor for pre-diabetes"}
                                </h5> */}

                                {/* umcomment the above part to display pre-diabetes results */}

                                {/* <h5 className='result' style={{marginBottom: '15px'}}>
                                    Based on your results, you have risk factors in: {matchingConditions.length > 0 ? 
                                        matchingConditions.join(', ') : 'No significant risk factors detected'}
                                </h5> */}

                                <div className="section-title" style={{marginTop: '30px', marginBottom: '30px'}}>
                                    <h2>Insulin Resistance Results</h2></div>
                                
                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Homeostasis Model Assessment of Insulin Resistance (HOMA-IR):</span> {homaIr}
                                    {/* {homaIr > 9 && 
                                        " - Indicates risk of Insulin Resistance"} */}
                                    
                                    {(responses.gender.trim() === 'Male' && homaIr > 1.85) || 
                                     (responses.gender.trim() === 'Female' && homaIr > 2.07) 
                                        ? " - Increased risk of pre-diabetes"
                                        : "HOMA IR score is within normal range"}
                                </h5>

                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Triglyceride Glucose Index (TyG):</span> {tyGIndex}
                                    {tyGIndex > 4.65 && 
                                        " - Indicates risk of Insulin Resistance"}
                                </h5>

                                <h5 className='result' style={{marginBottom: '15px'}}>
                                    <span style={{fontWeight: 'bold'}}>Triglyceride-HDL Ratio:</span> {hdlRatio}
                                    {(responses.gender.trim() === 'Male' && hdlRatio > 3.4) || 
                                     (responses.gender.trim() === 'Female' && hdlRatio > 2.6) 
                                        ? " - Indicates risk of Insulin Resistance"
                                        : " - Normal range"}
                                </h5>

                                {matchingConditions.length > 0 && (
                                    <h5 className='result' style={{marginBottom: '15px'}}>
                                        Your scores in <span style={{fontWeight: 'bold'}}>{matchingConditions.join(', ')} </span> are higher than the normal limits. 
                                        It indicates risk of Insulin resistance. Insulin resistance is underlying cause of many disorders 
                                        like weight gain, obesity, pre-diabetes, diabetes, high blood pressure, heart diseases, 
                                        polycystic ovarian syndrome (PCOS), Non alcoholic fatty liver disease (NAFLD) etc.
                                    </h5>
                                )}

                            </>
                        ) : <> </>}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ViewMedicalResponses; 